<template>
  <card-info>
    <div class="content">
      <card-header card="partner"></card-header>
      <tabs :tabs="tabs" :active="activeTab" @setTab="setTab" />
      <info v-if="activeTab === 0 && id" :id="id" />
    </div>
  </card-info>
</template>
<script>
import CardHeader from "../CardHeader";

import Tabs from "../../Tabs";

export default {
  name: "label",
  props: ["id"],
  components: {
    CardHeader,
    Tabs,
    info: () => import("./Info"),
  },
  data() {
    return {
      loading: true,
      tabs: [
        {
          title: "Информация",
        },
      ],
      activeTab: 0,
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    },
  },
  created() {},
};
</script>